import React, { memo } from 'react';

// External link that opens in a new tab/window, ensuring that the
// opened page doesn't have access to the current page.
//
// See: https://mathiasbynens.github.io/rel-noopener/
const ExternalLinkComponent = ({ children = null, ...rest }) => {
  return (
    <a {...rest} rel="noopener noreferrer" target="_blank">
      {children}
    </a>
  );
};

ExternalLinkComponent.displayName = 'ExternalLink';

const ExternalLink = memo(ExternalLinkComponent);

export default ExternalLink;
